module.exports = __webpack_public_path__ + "static/media/404.b7a59313.svg";